<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>Binary Text Converter</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs6>
            <v-textarea placeholder="Paste your text here" v-model="text"></v-textarea>
          </v-flex>
          <v-flex xs6>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" @click="textToBin()">Text to binary</v-btn>
            <v-btn color="primary" @click="binToText()">Binary to Text</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    text: '',
    result: ''
  }),
  methods: {
    textToBin() {
      let result = ''
      for (let i = 0; i < this.text.length; i++) {
        result += this.text[i].charCodeAt(0).toString(2) + ' '
      }
      this.result = result
    },
    binToText() {
      this.result = this.text
        .split(' ')
        .map(input => String.fromCharCode(parseInt(input, 2).toString(10)))
        .join('')
    }
  }
}
</script>

<style>
</style>